import React, { useState } from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";
import PageShell from "../components/PageShell";
import MarkdownLite from "../lib/MarkdownLite";
import EnquireModal from "../components/EnquireModal";
import { useContent } from "../contexts/ContentContext";

const KNOWN_KEYS = ["privacy", "terms", "refund"];

export default function LegalPage() {
  const params = useParams();
  const location = useLocation();
  const { content } = useContent();
  const [open, setOpen] = useState(false);

  // Determine page key: from URL param, or from pathname like "/privacy"
  let pageKey = params.pageKey;
  if (!pageKey) {
    const cleaned = location.pathname.replace(/^\/+|\/+$/g, "");
    if (KNOWN_KEYS.includes(cleaned)) pageKey = cleaned;
  }

  const page = pageKey ? content.legalPages?.[pageKey] : null;
  if (!page) return <Navigate to="/" replace />;

  return (
    <>
      <PageShell title={page.title} subtitle={page.lastUpdated} onEnquire={() => setOpen(true)}>
        <div className="bg-white border border-slate-200 rounded-2xl p-6 md:p-10 shadow-sm">
          <MarkdownLite text={page.content} />
        </div>
      </PageShell>
      <EnquireModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
